import { SET_ACTIVE_LINK, SET_ACTIVE_COLLAPSE } from '../ActionTypes.js';

const initActions = function (services) {
    const setActiveCollapse = (index) => {
        return {
            type: SET_ACTIVE_COLLAPSE,
            payload: index,
        };
    };

    const setActiveLink = (link) => {
        return {
            type: SET_ACTIVE_LINK,
            payload: link,
        };
    };

    return {
        setActiveCollapse,
        setActiveLink,
    };
};

export default initActions;
